import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const SectionTemplatesPage_List_AllSectionTemplates_QueryDocument =
  graphql(`
    query SectionTemplatesPage_List_AllSectionTemplates_Query {
      findAllSectionTemplates {
        _id
        code
        label
        statusId
      }
    }
  `);

export type SectionTemplatesPage_List_SectionTemplate = ResultOf<
  typeof SectionTemplatesPage_List_AllSectionTemplates_QueryDocument
>['findAllSectionTemplates'][number];

export const useFindAllSectionTemplatesQuery = () =>
  useGraphQLQuery(SectionTemplatesPage_List_AllSectionTemplates_QueryDocument);
